import React from "react";

/**
 * Componente de aviso de nova versão do PWA.
 *
 * TEMPORARIAMENTE DESATIVADO: enquanto o `vite-plugin-pwa` está desligado
 * no `vite.config.js` (para resolver cache de Service Worker entregando
 * bundle antigo no navegador do usuário), o módulo virtual
 * `virtual:pwa-register` não existe — e nenhum `@vite-ignore` no dev
 * server do Vite é suficiente para ele não tentar resolver o import e
 * quebrar com overlay vermelho.
 *
 * Para reativar depois:
 *   1. Volte o plugin `VitePWA({...})` no vite.config.js;
 *   2. Restaure este arquivo para a versão que usa `import("virtual:pwa-register")`.
 */
const AtualizacaoDisponivel = () => null;

export default AtualizacaoDisponivel;
